import React from "react";
import styles from "./ui.module.css";

/**
 * Underline-style tab switcher used across tab pages.
 *
 * Props:
 *  - tabs: Array<{ value: string, label: string, disabled?: boolean, testId?: string }>
 *  - activeTab: string — the current tab value
 *  - onTabChange: (value: string) => void
 *  - className: string — optional extra class on the outer container
 */
export const TabSwitcher = ({
  tabs = [],
  activeTab,
  onTabChange,
  className = "",
}) => {
  return (
    <div
      className={`${styles.tabSwitcher} ${className}`}
      role="tablist"
    >
      {tabs.map((tab) => {
        const isActive = tab.value === activeTab;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            data-testid={tab.testId}
            disabled={tab.disabled}
            onClick={() => onTabChange(tab.value)}
            className={`${styles.tab} ${isActive ? styles.tabActive : ""}`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};
